import { widgetBaseQuery } from '@/shared/utils/api';
import { createApi } from '@reduxjs/toolkit/query/react';

export const widgetBaseApi = createApi({
  reducerPath: 'widget',
  baseQuery: widgetBaseQuery(),
  tagTypes: ['Widget', 'MarketInfo', 'MarketChart'],
  endpoints: () => ({})
});
